// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // header
  aboutMe: 'Sobre mim',
  projects: 'Projetos',
  education: 'Formação',
  contact: 'Contato',

  // Bio
  hi: 'Olá',
  myName: 'Meu nome é',
  buildForWeb: 'E eu projeto para a WEB',

  // tech stack
  my: 'Minha',
  techWorking: "Tecnologias que utilizei recentemente",
  // projects
  ThingsIveBuilt: "Projetos em que eu participei até o momento",
  livePreview: 'Live Preview',
  viewCode: 'View Code',

  // contacts

  // about me

  // fatec
  FATECprojects: 'APIs - Projetos Integradores',
  FatecThingsIveBuilt: "Projetos APIs em que eu participei na FATEC São José dos Campos",
}